var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "report"
    }
  }, [Object.keys(_vm.getTransactions).length ? _c('div', {
    attrs: {
      "data-type": "list"
    }
  }, _vm._l(_vm.getTransactions, function (transactionArray, dateKey) {
    return _c('div', {
      key: dateKey
    }, [_c('div', {
      staticClass: "report-date-container"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatRelativeDate(dateKey)))])]), _c('ul', {
      staticClass: "list"
    }, _vm._l(transactionArray, function (transaction, index) {
      return _c('TransactionItem', {
        key: "".concat(transaction.owner_id, "_").concat(transaction.created_at, "_").concat(index),
        ref: "TransactionItem",
        refInFor: true,
        attrs: {
          "transaction": transaction
        }
      });
    }), 1)]);
  }), 0) : _vm.TRANSACTIONS.loading ? _c('img', {
    attrs: {
      "src": require("@/assets/img/loader.svg")
    }
  }) : _c('div', {
    staticClass: "empty-list"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('no.operations')))]), _c('video', {
    attrs: {
      "poster": require("@/assets/img/".concat(_vm.getIntroVideo.poster, ".png")),
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "https://docs.capusta.space/video/".concat(_vm.getIntroVideo.video, ".mp4"),
      "type": "video/mp4"
    }
  }), _vm._v(" Your browser does not support the video tag. ")])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [!_vm.isDeviceSize.desktop && _vm.SELECTED_TRANSACTION.owner_id ? _c('TransactionsSlider', {
    directives: [{
      name: "preventWindowScrolling",
      rawName: "v-preventWindowScrolling"
    }]
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }